<template>
  <div v-loading="processing || deleting">
    <el-row type="flex" justify="space-around">
      <el-col :span="2" align="center">
        <el-form-item v-if="category.editable">
          <el-switch v-model="active" @change="toggleDisabled"></el-switch>
        </el-form-item>
        <el-form-item v-else>
          <i class="fas fa-thumbtack"></i>
        </el-form-item>
      </el-col>
      <el-col :span="14">
        <el-input
          type="text"
          clearable
          v-model="tempObject.name"
          :disabled="!active"
          :readonly="!category.editable"
        />
      </el-col>
      <el-col :span="8" align="right">
        <el-form-item v-if="edited">
          <el-button @click="save" icon="fa fa-save" type="success" size="small"></el-button>
        </el-form-item>
        <el-form-item v-if="edited">
          <el-button @click="cancel" icon="fa fa-times" type="danger" size="small"></el-button>
        </el-form-item>
        <span v-show="!edited">
          <el-form-item v-if="!category.default">
            <el-button @click="setDefault" size="small">Set as Default</el-button>
          </el-form-item>
           <el-form-item v-else>
            <el-tag type="success" size="small">Default category</el-tag>
          </el-form-item>
          <el-form-item v-if="category.editable">
            <el-button @click="remove" icon="fa fa-trash" size="small" type="danger"></el-button>
          </el-form-item>
        </span>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { cloneDeep, isEqual } from 'lodash';
  import { mapGetters, mapActions } from 'vuex';

  import { showSuccessMessage, showErrorMessage } from '@/ui/message';

  export default {
    name: 'CategoryEditor',
    props: {
      category: {
        type: Object,
        required: true,
      },
      type: {
        type: String,
        required: true,
      },
      handleRemove: {
        type: Function,
      },
    },
    created() {
      this.tempObject = cloneDeep(this.category);
    },
    data() {
      return {
        tempObject: {},
        edited: false,
        active: false,
      };
    },
    computed: {
      ...mapGetters('entities/categories', ['isUpdating', 'isDeleting']),

      processing() {
        return this.isUpdating(this.category.id);
      },
      deleting() {
        return this.isDeleting(this.category.id);
      },
    },
    watch: {
      tempObject: {
        handler(newObject, oldObject) {
          if (newObject.status === 'active') {
            this.active = true;
          } else {
            this.active = false;
          }
          if (oldObject) {
            this.edited = !isEqual(this.category, newObject);
          }
        },
        deep: true,
      },
      category: {
        handler(newObject) {
          if (!this.edited) {
            this.tempObject = cloneDeep(newObject);
          }
        },
        deep: true,
      },
    },
    methods: {
      ...mapActions('entities/categories', ['fetchCategories', 'updateCategory', 'createCategory', 'removeCategory', 'setDefaultCategory']),

      save() {
        if (this.tempObject.id) {
          // Edit
          this.updateCategory({ id: this.category.id, data: this.tempObject })
            .then((response) => {
              if (response.status) {
                this.edited = false;

                showSuccessMessage('Category has been edited successfully.');
              } else {
                showErrorMessage(response.error.message);
              }
            });
        } else {
          // Create
          this.createCategory(this.tempObject)
            .then((response) => {
              if (response.status) {
                this.edited = false;

                this.handleRemove(this.tempObject.key);

                showSuccessMessage('Category has been added successfully.');
              } else {
                showErrorMessage(response.error.message);
              }
            });
        }
      },
      remove() {
        if (this.tempObject.id) {
          // Delete
          this.$confirm('Do you really want to remove this category?', 'Warning', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            title: 'Confirm',
          }).then(() => {
            this.removeCategory(this.tempObject.id)
              .then((response) => {
                if (response.status) {
                  showSuccessMessage('Category has been deleted successfully');
                } else {
                  showErrorMessage(response.error.message);
                }
              });
          });
        } else {
          this.handleRemove(this.tempObject.key);
        }
      },
      cancel() {
        this.tempObject = cloneDeep(this.category);
      },
      toggleDisabled() {
        const newStatus = (this.category.status === 'active') ? 'inactive' : 'active';
        this.updateCategory({ id: this.category.id, data: { status: newStatus } });
      },
      setDefault() {
        this.$confirm('Do you really want to set this category as default?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          title: 'Confirm',
        }).then(() => {
          this.setDefaultCategory({ id: this.category.id })
            .then((response) => {
              if (response.status) {
                this.fetchCategories({ type: this.category.type, app_id: this.category.app_id });

                showSuccessMessage(`${this.category.name} has been set as default category.`);
              } else {
                showErrorMessage(response.error.message);
              }
            });
        });
      },
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/category/CategoryEditor.vue